__turbopack_context__.v({
  "container": "styles-module__UwL4Qq__container",
  "userDetails": "styles-module__UwL4Qq__userDetails",
});
